export const AUTH_TOKEN_STORAGE_KEY = "myscore-service-composer-auth";

export const JWP_PREVIEW_MEDIA_URL =
  "https://www.jwpepper.com/sheet-music/media-player.jsp";

/** Flip to true when SKU parts UI is ready for customers. */
export const SHOW_SKU_PARTS_UI = false;
